<mat-card class="content-card">
  <div *appHasRoles="['admin', 'partner']" fxLayoutGap="10px">
    <mat-form-field>
      <mat-select placeholder="Select product" [(ngModel)]="productId" name="productId" required>
        <mat-option *ngFor="let product of products" [value]="product.id">{{product.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <app-file-upload (upload)="onUpload($event)" [uploadDisabled]="productId == null"></app-file-upload>
  </div>

  <app-mat-table-generator #table
  tableName="orderImportsTable"
  [columns]="columns"
  [dataSource]="dataSource"
  [multiselectEnabled]="false"
  [viewLink]="getViewLink"
  [deleteEnabled]="importDeleteEnabled()"
  [useEmbededFilter]="false"
  [rowClassCallback]="getRowClass">
</app-mat-table-generator>
</mat-card>
